import { createApp } from "vue";
import options from "./ChatPanelTrigger.options";

const el = ".nyk-component--chat-panel-trigger";

export default function (Store) {
  const DOM = document.querySelectorAll(el);
  DOM.forEach((ChatPanelTrigger) => {
    const template = ChatPanelTrigger.outerHTML;
    const actionId = ChatPanelTrigger.dataset.actionId;
    options.template = template;
    const component = createApp(options, { actionId }).use(Store);
    component.mount(ChatPanelTrigger);
  });
}
